<template>
  <q-btn
    icon="fa fa-file-download"
    :label="label"
    :title="title"
    v-bind="$attrs"
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import DownloadReportModal from './DownloadReportModal.vue';

export default defineComponent({
  props: {
    reportId: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: 'Download',
    },
  },
  computed: {
    title(): string {
      return this.label ? '' : 'Download';
    },
  },
  methods: {
    openModal() {
      const config = {
        parent: this,
        reportId: this.reportId,
      };
      openModal(DownloadReportModal, config);
    },
  },
});
</script>
